import { observer } from 'mobx-react-lite'
import { type SingleSelectFilter } from '@/infra/SingleSelectFilter'
import { match } from '@/utils/pattern-match-util'
import type {
  BookkeepingManagerActionFilter,
  BookkeepingManagerActionFilterOption,
} from '@/features/admin/bookkeeping/BookkeepingManagerSearchViewModel'
import {
  StatusFilterCards,
  type StatusFilterCardTone,
} from '@/features/admin/components/StatusFilterCards'

export interface BookkeepingManagerActionFilterContainerProps<
  TFilters extends Record<string, unknown>,
> {
  filter: SingleSelectFilter<keyof TFilters, BookkeepingManagerActionFilter>
}

export const BookkeepingManagerActionFilterContainer = observer(
  function BookkeepingManagerActionFilterContainer<
    TFilters extends Record<string, unknown>,
  >({ filter }: BookkeepingManagerActionFilterContainerProps<TFilters>) {
    return (
      <StatusFilterCards
        title={filter.title}
        selectedKey={filter.value.type}
        options={filter.options.map((opt) => ({
          key: opt.value.type,
          title: opt.title,
          count: opt.value.count,
          tone: actionTone(opt.value.type),
          testId: `bookkeeping-manager-action-filter-card-${actionTestIdSuffix(opt.value.type)}`,
          onSelect: () => filter.change(opt.value),
        }))}
      />
    )
  },
)

function actionTone(
  type: BookkeepingManagerActionFilterOption,
): StatusFilterCardTone {
  return match<BookkeepingManagerActionFilterOption, StatusFilterCardTone>(
    type,
    {
      All: 'Blue',
      ConfirmAccess: 'Red',
    },
  )
}

function actionTestIdSuffix(type: BookkeepingManagerActionFilterOption) {
  return match(type, {
    All: 'all',
    ConfirmAccess: 'confirm_access',
  })
}
